export default {
    address: 'Adresa',
    city: 'Grad',
    email: 'Email',
    phone: 'Telefon',
}
